module.exports = __webpack_public_path__ + "img/historico.b98a6d5b.svg";